module.exports = __webpack_public_path__ + "img/add-to-homescreen.acc996a5.png";